export default __webpack_public_path__ + "static/media/hypotenuse_logo_text_dark.43a4c5ad.svg";